const prefix = 'fasr';
const iconName = 'asterisk';
const width = 384;
const height = 512;
const aliases = [10033, 61545];
const unicode = '2a';
const svgPathData = 'M216 32V56 212.9l131.4-81.3 25.3 40.8L237.6 256l135 83.6-25.3 40.8L216 299.1V456v24H168V456 299.1L36.6 380.4 11.4 339.6l135-83.6-135-83.6 25.3-40.8L168 212.9V56 32h48z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
